<template>
  <header id="sub-header" class="sub-header">
      <div class="grid-container">
        <div class="top-bar">
          <div class="top-bar-center">
            <nav>
              <ul v-if="loading" class="menu main-menu">
                 <li class="menu-text" style="color: rgba(0,0,0,.5);">
                  Loading...
                </li>
              </ul>
              <ul v-else class="menu main-menu">
                <li v-for="item in menuList" :key="item.id">
                  <router-link
                    :to="{
                      name: 'catalog',
                      params: { catalog: item.id, entity: item },
                    }"
                    class="text-uppercase font-bold"
                  >
                    <span class="" style="">
                      {{ item.name }}
                    </span>
                  </router-link>
                </li>
              </ul>
              
            </nav>
          </div>
        </div>
      </div>
    </header>
</template>

<script>
import dataService from "@/store.catalog/services/main-service.js";

export default {
  name: "header-view",
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      menuList: [],
      currentCatalogId: null,

      loading: false,
      errored: false,
    };
  },
  mounted() {
    this.initMainCatalogs();
  },
  methods: {
    async initMainCatalogs() {
      try {
          this.loading = true;
          const {data} = await dataService.getMainCategories();
          this.setList(data);
      } catch (error) {
          this.errored = true;
          console.error(error);
      } finally {
          this.loading = false;
      }
    },
    setList(items){
      var itemsOrdered = items.sort((a, b) => a.sorting - b.sorting);
      this.menuList = itemsOrdered || [];
      if (this.menuList.length > 0) {
        this.currentCatalogId = this.menuList[0].id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../assets/sass/settings/settings";

$primary-bg-color: var(--primary-color);

#sub-header {
  overflow: hidden;

  //background: $light-gray;
  //background: #fff;
  background: $primary-bg-color;

  .top-bar,
  .top-bar ul,
  li {
    background: $primary-bg-color;
    
  }

  li{
    border-left: 1px solid #fff;
    // &:first-child{
    //   border-left: 1px solid #fff;
    // }
    // &:nth-child(2){
    //   border-left: 1px solid #fff;
    // }
    // &:nth-child(3){
    //   border-left: 1px solid #fff;
    // }
    &:last-child{
      border-right: 1px solid #fff;
    }
  }

  #main-header {
    text-align: center;
    background: rgba(255, 255, 255, 0.75);

    border: 0;
    //border-top: 1px solid #f5f5f5;
    //border-bottom: 1px solid #f5f5f5;
    //border-bottom: 1px solid #f5f5f5;
    //border-bottom-width: 1px;
    //border-bottom-style: solid;
    //border-bottom-color: rgb(245, 245, 245);
    z-index: 9;
    position: relative;

    a {
      color: $third-color;

      -moz-transition: all 0.35s ease;
    -o-transition: all 0.35s ease;
    -webkit-transition: all 0.35s ease;
    transition: all 0.35s ease;
    }
  }
}

.sub-header {
  justify-content: center;
  align-items: center;

  //border-bottom: 1px solid #efefef;

  .top-bar {
    justify-content: center;
    align-items: center;

    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }
}

.top-bar-center {
  .topbar-center-logo .top-bar-center {
    flex: 1 0 auto;

    @include breakpoint(small only) {
      display: none;
    }
  }
}

a i {
  padding-right: 0.25rem;
}

.main-menu {
  margin: 0 1rem;
}

.main-menu li {
  text-transform: inherit;
  position: relative;
}

.main-menu {
  a {
    position: relative;
    //color: #333;
    color: #fff;

    transition: all 0.35s ease;
  }
  // a::after {
  //   content: "";

  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   width: 85%;
  //   height: 2.5px;
  //   background: #666565;
  //   transform: scale(0, 0.5);
  //   transform-origin: 0;
  //   transition: all 0.35s ease;
  //   margin: 0 auto;
  // }
  a:hover {
    text-decoration: none;
    color: rgb(255, 255, 255);
    
    color: var(--primary-color);
    background: rgb(255, 255, 255);
    // &::after {
    //   background: rgb(255, 255, 255);
    // }
  }
  // a:hover::after {
  //   transform: scale(1, 0.5);
  // }
}

.logo-center {
  height: 30px;
}

.router-link-exact-active,
.router-link-active
 {
  text-decoration: none;
  //color: rgb(0, 0, 0) !important;
  //color: rgb(255,255, 255) !important;
  color: var(--primary-color) !important;

  font-weight: bold;
  //background: rgb(255, 255, 255) !important;
  background: rgb(255, 255, 255);

  border-radius: 2px;
  &::after {
    background: rgb(57, 133, 209) !important;
    // transform: scale(1, 0.5) !important;
  }
}
</style>
